import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import {
  SaveDriverAcceptanceRequest,
  VehicleOrderPolicyConfig,
  VehicleOrderPolicyContentResponse,
} from 'src/app/models/vehicle-order-policy-response.model';
import { ApiService } from '../api/api.service';
import { VehicleOrderProvider } from '../providers/vehicle-order-provider/vehicle-order-provider';

@Injectable({
  providedIn: 'root',
})
export class VehicleOrderInfoService {
  constructor(
    private readonly apiService: ApiService,
    private readonly vehicleOrderProvider: VehicleOrderProvider
  ) { }

  ensurePolicyConfig(): Observable<VehicleOrderPolicyConfig> {
    if (this.vehicleOrderProvider.isPolicyConfigLoaded()) {
      return of(this.vehicleOrderProvider.policyConfig()!);
    }
    return this.getVehicleOrderPolicyConfig().pipe(
      tap(config => this.vehicleOrderProvider.setPolicyConfig(config))
    );
  }

  getVehicleOrderPolicyConfig(): Observable<VehicleOrderPolicyConfig> {
    return this.apiService.get<VehicleOrderPolicyConfig>('vehicle-order-policy/config');
  }

  getVehicleOrderPolicyContent(): Observable<VehicleOrderPolicyContentResponse[]> {
    return this.apiService.get<VehicleOrderPolicyContentResponse[]>('vehicle-order-policy/content');
  }

  saveDriverAcceptance(request: SaveDriverAcceptanceRequest): Observable<void> {
    return this.apiService.post<SaveDriverAcceptanceRequest, void>(
      'vehicle-order-policy/save-driver-acceptance',
      request
    );
  }
}
